import { backEndApiAddressConfig, wnbAddressConfig, wnbPublicKeyConfig, baseAddressWithWnbConfig } from "config";

export const backEndApiAddress = backEndApiAddressConfig;
export const wnbAddress = wnbAddressConfig;
export const wnbPublicKey = wnbPublicKeyConfig;
export const baseAddressWithWnb = baseAddressWithWnbConfig;
